import { Injectable } from "@angular/core";
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { SystemCategoryService } from "src/app/Services/SystemCategoryService/system-category.service";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { ICategory } from "src/app/Models/Interface/SystemCategory/category";

@Injectable({
  providedIn: "root",
})
export class CategoryResolver implements Resolve<IBaseDataList<ICategory>> {
  constructor(private systemCategoryService: SystemCategoryService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IBaseDataList<ICategory>> {
    // @ts-ignore
    let parentId = 0;
    if (route.paramMap.get("id")) {
      // @ts-ignore
      parentId = +route.paramMap.get("id");
    } else {
      // @ts-ignore
      parentId = +route.paramMap.get("subCategoryId");
    }
    return this.systemCategoryService.getPaginatedCategories(parentId);
  }
}
